import React from 'react';
import { withStyles } from 'material-ui/styles';
import { withRouter } from "react-router-dom";
import SearchApp from './search_app.js';

const styles = theme => ({
});

class Home extends React.Component {
  render(){
    return(   	
    	<SearchApp src={'/google/q'} router={this.props.router} location={this.props.location}/>
    );
  }
}

withRouter(Home);
export default withStyles(styles)(Home);


// WEBPACK FOOTER //
// ./src/search/home.js